import { z } from 'zod';

export const optionalUrlSchema = z
  .string()
  .transform((val) => (val === '' ? null : val))
  .nullish()
  .refine((val) => val === null || z.string().url().safeParse(val).success, {
    message: 'Invalid URL',
  });

export const optionalEmailSchema = z
  .string()
  .transform((val) => (val === '' ? null : val))
  .nullish()
  .refine((val) => val === null || z.string().email().safeParse(val).success, {
    message: 'Invalid email',
  });
